import React from 'react';
import FactsheetDetailScreen from './FactsheetDetailScreen';
import { HistoryProps } from 'utils/history';

export default (props: HistoryProps) => (
  <FactsheetDetailScreen {...props} text={true} />
);
